import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { StyleManager } from 'src/app/services/style-manager.service';

@Component({
  selector: 'app-theme-customizer',
  templateUrl: './theme-customizer.component.html'
})
export class ThemeCustomizerComponent implements OnInit {

  @Output() closeDetails = new EventEmitter<boolean>();
  themeColor = localStorage.getItem('color') || 'light';

  constructor(private styleManager: StyleManager) { }

  ngOnInit(): void {

  }

  closeSidenav() {
    this.closeDetails.emit();
  }

  setThemeColor() {
    // console.log(this.themeColor);
    this.styleManager.toggleTheme(this.themeColor);
  }

}
